"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parsers = exports.Formatters = exports.Messages = exports.CurrentMessageLocale = exports.LocaleData = exports.getCurrentMessageLocale = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        //@ts-ignore
        globalContainer = window;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
exports.getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
/* istanbul ignore next */
exports.getCurrentMessageLocale = function () {
    var localize = getLocalize();
    if (localize.message.currentLocale === undefined) {
        throw Error('The localize.message.currentLocale has not been set');
    }
    return localize.message.currentLocale;
};
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
/* istanbul ignore next */
exports.CurrentMessageLocale = { get: function () { return exports.getCurrentMessageLocale(); } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    bold: function () { return t('@tableau__widgets/bold'); },
    cancel: function () { return t('@tableau__widgets/cancel'); },
    close: function () { return t('@tableau__widgets/close'); },
    closeDialog: function () { return t('@tableau__widgets/closeDialog'); },
    customColor: function () { return t('@tableau__widgets/customColor'); },
    edit: function () { return t('@tableau__widgets/edit'); },
    editorMode: function () { return t('@tableau__widgets/editorMode'); },
    enterValidDate: function () { return t('@tableau__widgets/enterValidDate'); },
    errorToastPrefix: function () { return t('@tableau__widgets/errorToastPrefix'); },
    formattingGuide: function () { return t('@tableau__widgets/formattingGuide'); },
    formattingHintsBold: function () { return t('@tableau__widgets/formattingHintsBold'); },
    formattingHintsColumnExample: function () { return t('@tableau__widgets/formattingHintsColumnExample'); },
    formattingHintsColumnMarkup: function () { return t('@tableau__widgets/formattingHintsColumnMarkup'); },
    formattingHintsImage: function () { return t('@tableau__widgets/formattingHintsImage'); },
    formattingHintsItalics: function () { return t('@tableau__widgets/formattingHintsItalics'); },
    formattingHintsLink: function () { return t('@tableau__widgets/formattingHintsLink'); },
    formattingHintsUnderline: function () { return t('@tableau__widgets/formattingHintsUnderline'); },
    heading1: function () { return t('@tableau__widgets/heading1'); },
    heading2: function () { return t('@tableau__widgets/heading2'); },
    heading3: function () { return t('@tableau__widgets/heading3'); },
    infoToastPrefix: function () { return t('@tableau__widgets/infoToastPrefix'); },
    italics: function () { return t('@tableau__widgets/italics'); },
    keyboardModifierCtrl: function () { return t('@tableau__widgets/keyboardModifierCtrl'); },
    keyboardModifierShift: function () { return t('@tableau__widgets/keyboardModifierShift'); },
    link: function () { return t('@tableau__widgets/link'); },
    linkText: function () { return t('@tableau__widgets/linkText'); },
    linkUrl: function () { return t('@tableau__widgets/linkUrl'); },
    nextMonth: function () { return t('@tableau__widgets/nextMonth'); },
    noMatches: function () { return t('@tableau__widgets/noMatches'); },
    optional: function () { return t('@tableau__widgets/optional'); },
    optionsSelected: function (a) { return t('@tableau__widgets/optionsSelected', a); },
    orderedList: function () { return t('@tableau__widgets/orderedList'); },
    paragraph: function () { return t('@tableau__widgets/paragraph'); },
    preview: function () { return t('@tableau__widgets/preview'); },
    previousMonth: function () { return t('@tableau__widgets/previousMonth'); },
    remove: function () { return t('@tableau__widgets/remove'); },
    required: function () { return t('@tableau__widgets/required'); },
    successToastPrefix: function () { return t('@tableau__widgets/successToastPrefix'); },
    skeletonLoaderLabel: function () { return t('@tableau__widgets/skeletonLoaderLabel'); },
    textEditorDisabledPreviewMode: function () { return t('@tableau__widgets/textEditorDisabledPreviewMode'); },
    textileLinkText: function () { return t('@tableau__widgets/textileLinkText'); },
    textilePreviewLabel: function () { return t('@tableau__widgets/textilePreviewLabel'); },
    underline: function () { return t('@tableau__widgets/underline'); },
    unorderedList: function () { return t('@tableau__widgets/unorderedList'); },
    waitIndicatorLabel: function () { return t('@tableau__widgets/waitIndicatorLabel'); },
    warningToastPrefix: function () { return t('@tableau__widgets/warningToastPrefix'); },
    weekNumber: function (a) { return t('@tableau__widgets/weekNumber', a); },
    optionCountAnnouncement: function (a) { return t('@tableau__widgets/optionCountAnnouncement', a); },
};
exports.Formatters = {
    formatFullMonthAndFullYear: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMMMM" }); },
    formatNarrowDayOfWeek: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "EEEEE" }); },
    formatShortDate: function (a) { return exports.getLocalizeFormat().formatDate(a, { "date": "short" }); },
    formatMediumDate: function (a) { return exports.getLocalizeFormat().formatDate(a, { "date": "medium" }); },
    formatLongDate: function (a) { return exports.getLocalizeFormat().formatDate(a, { "date": "long" }); },
    formatFullDate: function (a) { return exports.getLocalizeFormat().formatDate(a, { "date": "full" }); },
    formatShortDateTime: function (a) { return exports.getLocalizeFormat().formatDate(a, { "datetime": "short" }); },
    formatMediumDateTime: function (a) { return exports.getLocalizeFormat().formatDate(a, { "datetime": "medium" }); },
    formatLongDateTime: function (a) { return exports.getLocalizeFormat().formatDate(a, { "datetime": "long" }); },
    formatFullDateTime: function (a) { return exports.getLocalizeFormat().formatDate(a, { "datetime": "full" }); },
    formatShortDateWithFullYear: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMd" }); },
    formatShortDateTimeWithFullYear: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMdhm" }); },
    formatShortDateTimeWithFullYear24Hour: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMdHm" }); },
    formatShortDateMediumTimeWithFullYear: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMdhms" }); },
    formatShortDateMediumTimeWithFullYear24Hour: function (a) { return exports.getLocalizeFormat().formatDate(a, { "skeleton": "yyyyMdHms" }); },
    formatCount: function (a) { return exports.getLocalizeFormat().formatNumber(a, { "maximumFractionDigits": 0 }); },
};
exports.Parsers = {
    parseShortDate: function (a) { return exports.getLocalizeFormat().parseDate(a, { "date": "short" }); },
    parseMediumDate: function (a) { return exports.getLocalizeFormat().parseDate(a, { "date": "medium" }); },
    parseLongDate: function (a) { return exports.getLocalizeFormat().parseDate(a, { "date": "long" }); },
    parseFullDate: function (a) { return exports.getLocalizeFormat().parseDate(a, { "date": "full" }); },
    parseShortDateTime: function (a) { return exports.getLocalizeFormat().parseDate(a, { "datetime": "short" }); },
    parseMediumDateTime: function (a) { return exports.getLocalizeFormat().parseDate(a, { "datetime": "medium" }); },
    parseLongDateTime: function (a) { return exports.getLocalizeFormat().parseDate(a, { "datetime": "long" }); },
    parseFullDateTime: function (a) { return exports.getLocalizeFormat().parseDate(a, { "datetime": "full" }); },
    parseShortDateWithFullYear: function (a) { return exports.getLocalizeFormat().parseDate(a, { "skeleton": "yyyyMd" }); },
    parseShortDateTimeWithFullYear: function (a) { return exports.getLocalizeFormat().parseDate(a, { "skeleton": "yyyyMdhm" }); },
    parseShortDateTimeWithFullYear24Hour: function (a) { return exports.getLocalizeFormat().parseDate(a, { "skeleton": "yyyyMdHm" }); },
    parseShortDateMediumTimeWithFullYear: function (a) { return exports.getLocalizeFormat().parseDate(a, { "skeleton": "yyyyMdhms" }); },
    parseShortDateMediumTimeWithFullYear24Hour: function (a) { return exports.getLocalizeFormat().parseDate(a, { "skeleton": "yyyyMdHms" }); },
};
//# sourceMappingURL=Localize.js.map